module.exports = {
	"classes": [
		"healthcare-page",
		"header-dark"
	],
	"title": "Identity securely puts patients at the center of their healthcare experience.",
	"metas": {
		"description": "Secure personal health information and patients portals, build 360 degree views of the patient, and collaborate with partners. Welcome to the future of digital health."
	},
	"opengraph": {
		"og:title": "Identity securely puts patients at the center of their healthcare experience.",
		"og:description": "Secure personal health information and patients portals, build 360 degree views of the patient, and collaborate with partners. Welcome to the future of digital health.",
		"og:url": "https://auth0.com/healthcare",
		"og:image": "https://cdn.auth0.com/website/healthcare/healthcare-twitter-card.png",
		"og:image:secure_url": "http://cdn.auth0.com/website/healthcare/healthcare-twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "Identity securely puts patients at the center of their healthcare experience.",
		"twitter:description": "Secure personal health information and patients portals, build 360 degree views of the patient, and collaborate with partners. Welcome to the future of digital health.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/healthcare/healthcare-twitter-card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/healthcare/metadata.json
// module id = 1394
// module chunks = 0